<template>
  <div class="home">

    <!-- 轮播图 -->
    <div class="vant-swipe" style="margin: 0; padding: 0;">
        <van-swipe :loop="true" :show-indicators="true" :autoplay="5000" style="height:108px;" indicator-color="white">
            <van-swipe-item v-for="(image,index) in images" :key="image.id">
                <img v-lazy="image.img"  style="width: 100%; height: 108px;"/>
            </van-swipe-item>
        </van-swipe>
    </div>

    <van-grid clickable :column-num="2" icon-size="26px">
      <van-grid-item icon="play-circle-o" text="查谱视频教程" to="/video/detail" />
      <van-grid-item icon="orders-o" text="查谱文档教程" to="/doc/detail" />
    </van-grid>

    <van-notice-bar wrapable :scrollable="false">
      请在搜索框中输入您的族谱名称或支系名称。如果您不清楚族谱名称或支系名称，请向家中长辈询问。如果查询不到，说明您所在的家族尚未整理族谱数据。
    </van-notice-bar>
      <!--搜索-->
      <van-search v-model="searchQuery" background="#ed3f2c" placeholder="请输入族谱名称或支系名称搜索" />

    <!--列表-->
    <div style="height: 6px;"></div>

     <template v-for="item in filterItems()">
        <van-cell-group v-if="item.close==0">
          <van-cell :title="item.name" is-link :url="item.url" v-if="item.url"/>
          <van-cell :title="item.name" is-link :to="'/ychome/detail?id='+item.id" v-else/>
        </van-cell-group>
        <van-cell-group v-else>
          <van-cell :title="item.name" is-link :to="'/ychomelist?id='+item.id+'&name='+item.name"/>
        </van-cell-group>
     </template>

  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'

export default {
    'name': 'Home',
    data() {
        return {
          images: [
              {id:1,img: require('../../../public/static/tb1.png')}
          ],
          searchQuery:''
        };
    },
    computed: {
       ...mapState({
            list: state => state.root.manual_one
       })
    },
    methods: {
        ...mapActions(['requestManualOne']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        filterItems() {
          const query = this.searchQuery.toLowerCase()
          if(this.list) {
            return this.list.filter(item =>
              item.name.toLowerCase().includes(query)
            )
          }
        }
    },
    mounted() {
      this.requestManualOne({"thit":this});
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/* 轮播样式 */
.vant-swipe {
    padding: 0px 5px 5px 5px;
}

.home >>> .van-button--info {
    color: #fff;
    background-color: #ed3f2c;
    border: 0.02667rem solid #ed3f2c;
}
</style>
